import { useEffect, useMemo } from 'react';
import type { AuthState } from './context';
import { setAuthHeadersProvider } from '@/api/auth-headers';
import type { AppConfig } from '@/config';

/** Dev bypass: a fixed session, and the API is told who we are with X-Org-Id and X-User. */
export function useDevAuth(cfg: AppConfig, active: boolean): AuthState | null {
  useEffect(() => {
    if (!active) return;
    setAuthHeadersProvider(() => ({ 'X-Org-Id': cfg.devOrgId, 'X-User': cfg.devUser }));
  }, [active, cfg.devOrgId, cfg.devUser]);

  return useMemo<AuthState | null>(
    () =>
      active
        ? {
            mode: 'dev',
            loading: false,
            user: { email: 'dev@localhost', name: cfg.devUser },
            signInWithEmail: async () => undefined,
            verifyEmailCode: async () => undefined,
            signOut: async () => undefined,
            error: null,
          }
        : null,
    [active, cfg.devUser],
  );
}
